import Slide from '../../Slide/Slide'
import {
  ButtonGroup,
  ButtonRect,
} from '../../OnboardingButtons/OnboardingButtons'
import css from './adoption-age.styles.scss'

export default ({ onSaveArrivalAge }) => (
  <div className={css.AdoptionAge__container}>
    <Slide title="How old will the baby be when they arrive?">
      <ButtonGroup>
        <ButtonRect
          className={css.AdoptionAge__button}
          onClick={() => onSaveArrivalAge('0-3 Months')}
        >
          <span className={css.AdoptionAge__upperButtonLabel}>0–3</span>
          <span className={css.AdoptionAge__lowerButtonLabel}>Months</span>
        </ButtonRect>
        <ButtonRect
          className={css.AdoptionAge__button}
          onClick={() => onSaveArrivalAge('3-6 Months')}
        >
          <span className={css.AdoptionAge__upperButtonLabel}>3–6</span>
          <span className={css.AdoptionAge__lowerButtonLabel}>Months</span>
        </ButtonRect>
        <ButtonRect
          className={css.AdoptionAge__button}
          onClick={() => onSaveArrivalAge('6-12 Months')}
        >
          <span className={css.AdoptionAge__upperButtonLabel}>6–12</span>
          <span className={css.AdoptionAge__lowerButtonLabel}>Months</span>
        </ButtonRect>
        <ButtonRect
          className={css.AdoptionAge__button}
          onClick={() => onSaveArrivalAge('1 Year+')}
        >
          <span className={css.AdoptionAge__upperButtonLabel}>1+</span>
          <span className={css.AdoptionAge__lowerButtonLabel}>Year</span>
        </ButtonRect>
        <ButtonRect
          className={css.AdoptionAge__button}
          onClick={() => onSaveArrivalAge('Not sure')}
        >
          <span className={css.AdoptionAge__lowerButtonLabel}>Not Sure</span>
        </ButtonRect>
      </ButtonGroup>
    </Slide>
  </div>
)
